import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import css from './ChartLegend.css';

const LEGEND_PREFIX = 'STATIC.PAGES.ANOMALY_ANALYSIS.LEGEND';

const ChartLegend = ({ chartColors }) => (
    <div className={css.legend}>
        <div className={css.legendItem}>
            <div className={css.legendColor} style={{ backgroundColor: chartColors?.noData }} />
            <Translate id={`${LEGEND_PREFIX}.NO_DATA`} />
        </div>
        <span className={css.legendLabel}>
            <Translate id={`${LEGEND_PREFIX}.WORST`} />
        </span>
        <div
            className={css.gradientBar}
            style={{
                background: `linear-gradient(to right, ${chartColors?.negative}, ${chartColors?.neutral} 50%, ${chartColors?.positive})`,
            }}
        />
        <span className={css.legendLabel}>
            <Translate id={`${LEGEND_PREFIX}.BEST`} />
        </span>
    </div>
);

ChartLegend.propTypes = {
    chartColors: PropTypes.object,
};

export default ChartLegend;
